<template>
    <div class="link-analytics-practice" @click="routeAnalyticsPractice">
        <span class="link-analytics-practice__heading">Pratikler</span>
        <span class="link-analytics-practice__text">Pratik oturumlarında ne kadar ter döktüğünü incele</span>
        <span class="link-analytics-practice__art-pattern--left"></span>
        <span class="link-analytics-practice__art-pattern--right"></span>
        <span class="link-analytics-practice__art-cute-brain"></span>
    </div>
</template>
<script>
    export default {
        methods: {
            routeAnalyticsPractice(){
                this.$router.push('/analytics/practice')
            }
        }
    };
</script>
<style scoped src="@/css/components/link-analytics-practice.css"></style>